import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { Base } from "../../framework/base";
import { IWorkTimePageMainStateProps, IWorkTimePageMainDispatchProps, IWorkTimePageMainOwnProps, WorkTimePageMain } from "../../components/workTime/workTimePageMain";
import { IEmployeeParameters } from "../../models/employee/employeeIParameters";

export function mapStateToProps(applicationState: IApplicationState): IWorkTimePageMainStateProps {
    if (Base.isNullOrUndefined(applicationState) || Base.isNullOrUndefined(applicationState.owner)) {
        return {
            owner: null,
            user: null
        };
    }
    return {
        owner: applicationState.owner,
        user: applicationState.user
    };
}

export function mapDispatchToProps(dispatch: storeEffects.SettingsThunkDispatch): IWorkTimePageMainDispatchProps {
    return {
        setEmployeeParameters: (parameters: IEmployeeParameters, saveToDb: boolean) => dispatch(storeEffects.setEmployeeParameters(parameters, saveToDb)),
        onLogout: () => dispatch(storeEffects.logout())
    };
}

export default connect<IWorkTimePageMainStateProps, IWorkTimePageMainDispatchProps, IWorkTimePageMainOwnProps>(mapStateToProps, mapDispatchToProps)(WorkTimePageMain);
